import { parseData } from '@devhacker/shared/utils/parseData';
import { createLoggerInterceptorsV2 } from '@devhacker/shared/libs/logger';
import { getAuthInterceptors } from '@devhacker/shared/features/auth/utils/interceptors';
import { mergeInterceptors } from '@devhacker/shared/utils/mergeInterceptors';

import { API_TIMEOUT, PUSHER_API_URL } from '~/constants/config';
import {
  type FetchNotificationsResponse,
  fetchNotificationsResponseSchema,
  type ResetNotificationsResponse,
  resetNotificationsResponseSchema,
} from './schema';

export const pusherFetch = $fetch.create({
  baseURL: PUSHER_API_URL,
  timeout: API_TIMEOUT,
  credentials: 'include',
  ...mergeInterceptors([createLoggerInterceptorsV2('pusher'), getAuthInterceptors('pusher')]),
});

export async function fetchNotifications(integerId: string, params: any) {
  const { $isDebug } = useNuxtApp();
  const url = `/api/v1/kolokolchick/user/${integerId}`;
  const data = await pusherFetch<FetchNotificationsResponse>(url, { params });
  return parseData(data, fetchNotificationsResponseSchema, $isDebug);
}

export async function resetNotifications(integerId: string) {
  const { $isDebug } = useNuxtApp();
  const url = `/api/v1/kolokolchick/user/${integerId}/notifications/mass-viewing`;
  const data = await pusherFetch<ResetNotificationsResponse>(url, { method: 'patch' });
  return parseData(data, resetNotificationsResponseSchema, $isDebug);
}
